import { render } from "./ContactInfoView.vue?vue&type=template&id=285942b9&scoped=true"
import script from "./ContactInfoView.vue?vue&type=script&lang=js"
export * from "./ContactInfoView.vue?vue&type=script&lang=js"

import "./ContactInfoView.vue?vue&type=style&index=0&id=285942b9&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285942b9"]])

export default __exports__